import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Roles } from "../../config/Roles";
import MenuGroup from "./MenuGroup";
import MenuItem from "./MenuItem";
import HandymanIcon from "@mui/icons-material/Handyman";
import PersonIcon from "@mui/icons-material/Person";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Divider } from "@mui/material";

const RACE_CONFIG_ITEMS = [
  {
    link: "/races",
    label: "Závody",
    icon: <HandymanIcon />,
    roles: Roles.editors,
  },
  {
    link: "/merchandise",
    label: "Doplňkové služby",
    icon: <ShoppingCartOutlinedIcon />,
    roles: Roles.editors,
  },
  {
    link: "/photos",
    label: "Správa fotek",
    icon: <PhotoLibraryIcon />,
    roles: Roles.photoEditors,
  },
  {
    link: "/accreditation",
    label: "Akreditace",
    icon: <HowToRegIcon />,
    roles: Roles.registrationOperators,
  },
  {
    link: "/masters",
    label: "Masters",
    icon: <LoyaltyIcon />,
    roles: Roles.editors,
  },
];

const ADMINISTRATION_ITEMS = [
  {
    link: "/userManagement",
    label: "Uživatelé",
    icon: <AdminPanelSettingsOutlinedIcon />,
  },
  {
    link: "/appConfig",
    label: "Konfigurace",
    icon: <SettingsIcon />,
  },
];

function MenuItems({ menuOpen }) {
  return (
    <nav>
      <MenuItem to={"/"} icon={<DashboardIcon />} label={"Můj Dashboard"} />
      <MenuItem to={"/gallery"} icon={<PhotoLibraryIcon />} label={"Fotogalerie"} />
      <MenuItem to={"/user"} icon={<PersonIcon />} label={"Nastavení účtu"} />

      <MenuGroup
        groupId={"raceConfig"}
        title={"Konfigurace závodů"}
        items={RACE_CONFIG_ITEMS}
        roles={[...Roles.registrationOperators, Roles.photograph]}
        menuOpen={menuOpen}
      />

      <MenuGroup
        groupId={"administration"}
        title={"Administrace"}
        items={ADMINISTRATION_ITEMS}
        roles={[Roles.admin, Roles.editor]}
        menuOpen={menuOpen}
      />

      <Divider />

      <MenuItem to={"/support"} icon={<HelpOutlineIcon />} label={"Podpora"} />
    </nav>
  );
}

export default MenuItems;
